export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = `0689a6cf-537e-4c9a-aae8-72a5d2bfe113`;
export const MODAL_CLOSE_SEC = 2.5;

